var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4286_2460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6748 5.82792C20.6748 4.99707 20.0014 4.32617 19.1737 4.32617C18.3459 4.32617 17.6719 4.99707 17.6719 5.82792C17.6719 6.65573 18.3459 7.32663 19.1737 7.32663C20.0014 7.32663 20.6748 6.65573 20.6748 5.82792Z",
    fill: "url(#paint0_linear_4286_2460)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6735 17.5505C22.6179 18.7693 22.414 19.4315 22.2448 19.8714C22.0175 20.4545 21.7463 20.8715 21.3065 21.309C20.8715 21.7462 20.4545 22.0169 19.8714 22.2417C19.4315 22.4135 18.7668 22.6179 17.548 22.676C16.2303 22.734 15.8399 22.7465 12.4984 22.7465C9.1601 22.7465 8.76656 22.734 7.4489 22.676C6.23008 22.6179 5.56848 22.4135 5.1286 22.2417C4.54235 22.0169 4.12848 21.7462 3.6911 21.309C3.25063 20.8715 2.97946 20.4545 2.75521 19.8714C2.58592 19.4315 2.379 18.7693 2.32646 17.5505C2.26223 16.2328 2.25048 15.8362 2.25048 12.5016C2.25048 9.1601 2.26223 8.76656 2.32646 7.44889C2.379 6.23008 2.58592 5.56848 2.75521 5.1249C2.97946 4.54235 3.25063 4.12783 3.6911 3.69046C4.12848 3.25373 4.54235 2.98252 5.1286 2.75521C5.56848 2.58285 6.23008 2.38146 7.4489 2.3234C8.76656 2.26529 9.1601 2.25048 12.4984 2.25048C15.8399 2.25048 16.2303 2.26529 17.548 2.3234C18.7668 2.38146 19.4315 2.58285 19.8714 2.75521C20.4545 2.98252 20.8715 3.25373 21.3065 3.69046C21.7463 4.12783 22.0175 4.54235 22.2448 5.1249C22.414 5.56848 22.6179 6.23008 22.6735 7.44889C22.7346 8.76656 22.7494 9.1601 22.7494 12.5016C22.7494 15.8362 22.7346 16.2328 22.6735 17.5505ZM24.924 7.34635C24.8629 6.01446 24.6527 5.1045 24.3408 4.31196C24.0233 3.48971 23.5977 2.79287 22.9008 2.09604C22.2071 1.40232 21.5102 0.976675 20.688 0.655458C19.8924 0.346564 18.9855 0.13404 17.653 0.0759858C16.3205 0.0117238 15.8949 0 12.4984 0C9.1051 0 8.6764 0.0117238 7.3439 0.0759858C6.01446 0.13404 5.10821 0.346564 4.30885 0.655458C3.48971 0.976675 2.79287 1.40232 2.09915 2.09604C1.40232 2.79287 0.976673 3.48971 0.656056 4.31196C0.347165 5.1045 0.137142 6.01446 0.0728798 7.34635C0.0148261 8.67885 0 9.1051 0 12.5016C0 15.8949 0.0148261 16.3205 0.0728798 17.653C0.137142 18.9824 0.347165 19.8917 0.656056 20.688C0.976673 21.5073 1.40232 22.2071 2.09915 22.9008C2.79287 23.5946 3.48971 24.0233 4.30885 24.344C5.10821 24.6527 6.01446 24.8629 7.3439 24.924C8.6764 24.9852 9.1051 25 12.4984 25C15.8949 25 16.3205 24.9852 17.653 24.924C18.9855 24.8629 19.8924 24.6527 20.688 24.344C21.5102 24.0233 22.2071 23.5946 22.9008 22.9008C23.5977 22.2071 24.0233 21.5073 24.3408 20.688C24.6527 19.8917 24.8629 18.9824 24.924 17.653C24.9852 16.3205 25 15.8949 25 12.5016C25 9.1051 24.9852 8.67885 24.924 7.34635Z",
    fill: "url(#paint1_linear_4286_2460)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4987 16.664C10.1987 16.664 8.33251 14.8008 8.33251 12.5009C8.33251 10.1973 10.1987 8.33171 12.4987 8.33171C14.7992 8.33171 16.6679 10.1973 16.6679 12.5009C16.6679 14.8008 14.7992 16.664 12.4987 16.664ZM12.4987 6.07812C8.95334 6.07812 6.08203 8.9556 6.08203 12.5009C6.08203 16.0432 8.95334 18.9176 12.4987 18.9176C16.0439 18.9176 18.9184 16.0432 18.9184 12.5009C18.9184 8.9556 16.0439 6.07812 12.4987 6.07812Z",
    fill: "url(#paint2_linear_4286_2460)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4286_2460",
    x1: 0.227089,
    y1: 24.7414,
    x2: 22.9193,
    y2: 2.04936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4286_2460",
    x1: 0.225495,
    y1: 24.7727,
    x2: 22.9365,
    y2: 2.06177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4286_2460",
    x1: 0.231591,
    y1: 24.7726,
    x2: 22.937,
    y2: 2.06724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4286_2460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e1386e8afef49b0ad53200fd74516885.svg";
export { ForwardRef as ReactComponent };